import React, {useState, useMemo} from "react";
import Modal from 'react-bootstrap/Modal';
import {SetMetaData} from './../../helper/page-title';
import {LoaderMedium} from './../../components/loader';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DOMPurify from 'dompurify';
import moment from 'moment';
import {
  Form
} from 'react-bootstrap';
import useInfiniteList from "../../hooks/infinite-list";
import useColumnSettings from "../../hooks/column-setting";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import FilterInput from "../../components/form/filter/filter-input";
import ValidationHelper from "../../helper/validation";
import normalizeFilters from "../../helper/filter/normalize-filter";
import {SettingDropdownUi, RowDataUi} from "../../components/form/master-table/ui-static";
import {post_api_call,
        get_api_call,
        error_api_call
      } from './../../actions/action-creators/common';
import { alertResponseMessage } from "../../actions/action-creators/response";
//Modal
import FormDataNomi from "../../data/formData/support/contact";
import {toggleBodyLoader} from './../../helper/custom-function';
import { contactRoleData } from "../../data/formData/option";

const {
    masterTableFields,
    fieldValuesReply,
    fieldValidationReply
} = FormDataNomi;

function ManangeSupport(props){
    SetMetaData("Manage Contacts", "", "");
    const [filterData, setFilterData] = useState({});
    const [modalLoader, setModalLoader] = useState({detail: false, reply: false});
    const [modalToggle, setModalToggle] = useState({detail: false, reply: false});
    const [errorData, setErrorData] = useState({reply: []});
    const [isProcess, setIsProcess] = useState({reply: false});
    //Single Details
    // const [detailedContactData, setDetailedContactData] = useState({});
    const [contactReplyData, setContactReplyData] = useState({...fieldValuesReply});
    // const [refreshKey, setRefreshKey] = useState(0);
    const { columnSettings, updateColumn } = useColumnSettings({
            id: true,
            email: true,
            role_id: true,
            name: true,
            message_query: true,
            created_at: true
        });
    
    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {}),
        [filterData]
    );

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["manage_contact", 0],
        apiCall: payload => post_api_call("contacts", payload),
                limit: 100,
                extraPayload: {
                    fetch_type: "manage_contact",
                    filter: normalizedFilter
                }
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];
    //View Data
    const loadViewModal = async(e, load_type, modal_data) => {
        e.preventDefault();
        try{
            //Page Loading
            toggleModal(e, load_type, true);
            setModalLoader({...modalLoader, [load_type]: true});

            // if(load_type === 'detail'){
            //     setDetailedContactData({...modal_data});
            // }
            if(load_type === 'reply'){
                setContactReplyData({message_query: modal_data.message_query,
                                    contact_id: modal_data.id,
                                    replies: [],
                                    message: `Hello ${modal_data?.user?.full_name}, <br/><br/><br/><br/><br/><br/><br/><br/>-IFSPD Europe Directorate`,
                                    message_text: ''
                                });
                //Get Data
                const replyApiData = await get_api_call(`contact-replies/${modal_data.id}`, {});
                if(replyApiData.status === 200){
                    setContactReplyData(prevState => ({
                        ...prevState,
                        replies: replyApiData.data
                    }));
                    
                    setModalLoader(prevLoader => ({ 
                        ...prevLoader, 
                        [load_type]: false 
                    }));
                }
            }else{
                setModalLoader(prevLoader => ({ 
                    ...prevLoader, 
                    [load_type]: false 
                }));
            }
        }catch(error){
            error_api_call({error: `admin|screens|support|manage|loadViewModal|${error}`});
            alertResponseMessage({alert_type: 2, message: "Error Loading Data"});
        }
    }
    //Update Input
    const updateInput = (form_type, attrName, value) => {
        try {
            if(form_type === "filter"){
                let fields = {...filterData};
                fields[attrName] = value;
                setFilterData({...fields});
            }else if(form_type === "reply"){
                if(attrName === "message"){
                    setContactReplyData(prevState => ({
                        ...prevState,
                        message     : value,
                        message_text: value
                    }));
                }
            }
        } catch (error) {
            console.error(error);
            error_api_call({
                error: `admin/screens/support/manage|updateInput|${error}`
            });
        }
    };
    // Toggle Modal
    const toggleModal = (e, modal_type, toggleState) => {
        try{
            if(toggleState){
                e.preventDefault();
            }
            setModalToggle({...modalToggle, [modal_type]: toggleState});
        }catch(error){
            console.log(error)
        }
    }
    //Reply To Message
    const replyToMessage = async(e, id) => {
        e.preventDefault();
        try{
            setErrorData({...errorData, reply: []});
            setIsProcess({...isProcess, reply: true});
            //Validation
            const validation = ValidationHelper.validation(contactReplyData, fieldValidationReply).error;

            if(validation.length){
                setErrorData({...errorData, reply: validation});
                setIsProcess({...isProcess, reply: false});
            }else{
                if (window.confirm(`Are you sure you want to send this reply mail?`)){
                    toggleBodyLoader('load');

                    const replyApiData = await post_api_call(`contact/reply`,
                                        {contact_id: contactReplyData.contact_id, message: contactReplyData.message});

                    if(replyApiData.status === 200){
                        alertResponseMessage({alert_type: 1, message: `Reply sent Successfully!`});
                        setModalToggle(prevToggle => ({ 
                            ...prevToggle, 
                            reply: false 
                        }));
                    }

                    toggleBodyLoader('remove');
                }
            }

            setIsProcess({...isProcess, reply: false});
        }catch(error){
            toggleBodyLoader('remove');
            setIsProcess({...isProcess, reply: false});
            error_api_call({error: `admin|screen|support|manage|replyToMessage|${error}`});
        }
    }

    return (
        <>
        <div className="row">
          <InfiniteListWrapper
              dataLength={masterTableData.length}
              isLoading={isLoading}
              hasNextPage={hasNextPage}
              fetchNextPage={fetchNextPage}
              isFetchingNextPage={isFetchingNextPage}
              emptyMessage="No Record found!"
          >
              <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                      {/* SETTINGS */}
                      <SettingDropdownUi
                          checkedData={columnSettings}
                          fields={masterTableFields}
                          updateColumn= {(field, value) => updateColumn(field, value)}
                      />

                      {/* TABLE */}
                      <div className="card-body table-responsive sticky-table pt-0 pe-0 ps-3">
                          <table className="table">
                              <thead>
                              <tr>
                                  {masterTableFields.map((col, i) => (
                                  (typeof col.accessRoleIds === "undefined" ||
                                      props.userRoleIds.some(role =>
                                      col.accessRoleIds.includes(role)
                                      )) &&
                                      columnSettings[col.field.name] && (
                                          <th key={i} className={`w-200p ${col.class_name || ""}`}>
                                          {col.title}
                                          {col.is_searchable && (
                                              <FilterInput
                                                  formType="filter"
                                                  field={col?.field}
                                                  data={filterData}
                                                  selectOptions={
                                                    (col.field?.type === "multi-select"
                                                    || col.field?.type === "select")
                                                    ?
                                                        {role_id: {
                                                            value: 'id',
                                                            label: 'role',
                                                            data: contactRoleData
                                                        }}
                                                    :
                                                        {}
                                                    }
                                                  _updateInput= {(form_type, data_type, input_type, field, value) => updateInput(form_type, field, value)}
                                              />
                                          )}
                                          </th>
                                      )
                                  ))}
                                  <th>Action</th>
                              </tr>
                              </thead>

                              <tbody>
                              {isLoading ? (
                                  <tr>
                                      <td colSpan="20" className="text-center p-4">
                                          <img
                                              alt="Loader"
                                              src={require("../../assets/images/Image-Loader.gif")}
                                          />
                                      </td>
                                  </tr>
                              ) : (
                                  masterTableData.length > 0 
                                  ? (
                                      masterTableData.map((row, index) => {
                                      return (
                                          <tr
                                              key={index}
                                          >

                                              {masterTableFields.map((tbl, i) => (
                                                  (typeof tbl.accessRoleIds === "undefined" ||
                                                  props.userRoleIds.some(role =>
                                                      tbl.accessRoleIds.includes(role)
                                                  )) &&
                                                  columnSettings[tbl.field.name] && (
                                                  <td key={i}>
                                                      {/* {row[tbl.fetch_key]} */}
                                                      <div className="three-line">
                                                      <RowDataUi
                                                          fetch_key={tbl.fetch_key}
                                                          data={row}
                                                          data_type={tbl.data_type ?? "text"}
                                                      />
                                                      </div>
                                                  </td>
                                                  )
                                              ))}

                                              <td className="d-flex">
                                                    <button
                                                        onClick={(e) => loadViewModal(e, 'reply', row)}
                                                        className={`btn btn-sm btn-behance`}
                                                        title="Reply"
                                                    >
                                                        <i className="mdi mdi-message-reply-text"></i>
                                                    </button>

                                                    {/* <button
                                                        onClick={(e) => loadViewModal(e, 'detail', row)} className="btn btn-sm btn-twitter ms-2" title="View Data"
                                                    ><i className="mdi mdi-eye"></i></button> */}

                                                    {row.role_id === 1 && (
                                                    <a href={`/student/${row.user?.url}`} target="_blank" rel="noreferrer"><button className="btn btn-sm btn-twitter ms-2" title="View Profile"><i className="mdi mdi-account-arrow-right"></i></button></a>)}
                                              </td>
                                          </tr>
                                      );
                                      })
                                  )
                                  : 
                                  <tr>
                                      {/* <td colSpan={props.userRoleIds.includes(2) ? 13 : 11}> */}
                                      <td colSpan="20">
                                      <div className="no-fellow text-center mt-4">
                                          {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                          <p className="pt-4 head">{"No Record Found!"}</p>
                                      </div>
                                      </td>
                                  </tr>
                              )}
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </InfiniteListWrapper>
        </div>
        {/* View Contact Details */}
        {/* <ModalMasterDetail
            data={detailedContactData}
            isShow={modalToggle.detail}
            _toggleModal={(e, state) => toggleModal(e, 'detail', state)}
            loader={modalLoader.detail}
            _formData={[{label: "About Your School", fields: [...fieldNomiView1]},
                        {label: "Nomination to IFSPD Europe Future Global Leaders Fellowship", fields: [...fieldNomiView2]},
                        {label: "Contact Details", fields: [...fieldNomiView3]}
                    ]}
            title={"School Nomination Details"}
        /> */}
        {/* Reply to Query */}
        <Modal dialogClassName="z-index-99999" show={modalToggle.reply} onHide={(e) => toggleModal(e, 'reply', false)} size="lg" className="mod-custom team-detail" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Reply to Query</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="scroll-wrap">
                    <div className="scroll-div">
                        <Form className="filter-form">
                            <fieldset>
                                <legend>Reply</legend>
                                <div className="row m-0">
                                    {/* Message */}
                                    <p className="ps-0"><b>Query: </b><i>{contactReplyData.message_query}</i></p>
                                    <div className="table-responsive sticky-table p-0 h-min-auto">
                                        <CKEditor
                                            editor={ ClassicEditor }
                                            data={contactReplyData.message}
                                            onChange={ ( event, editor ) => {
                                                // const data = editor.getData();
                                                // console.log( { event, editor, data } );
                                                updateInput('reply','message', editor.getData())
                                            }}
                                            onReady={(editor) => {
                                                // You can store the "editor" and use when it is needed.
                                                // console.log("Editor is ready to use!", editor);
                                                editor.editing.view.change((writer) => {
                                                    writer.setStyle(
                                                        "height",
                                                        // `${field.height ? field.height : '200'}px`,
                                                        '300px',
                                                        editor.editing.view.document.getRoot()
                                                    );
                                                });
                                            }}
                                            config={ {
                                                toolbar: [ 'bold', '|', 'italic', '|', 'bulletedList', '|', 'numberedList'],
                                            }}
                                        />
                                    </div>
                                </div>
                            </fieldset>

                            {/* Error */}
                            {(errorData.reply && errorData.reply.length > 0) && (
                                <div className="col-md-12 col-12 col-sm-12 ps-2 pe-2 ps-sm-3 pe-sm-3">
                                    <div className="alert alert-danger mt-4" role="alert">
                                        <p>Please enter/modify following Data:</p>
                                        <ol>
                                        {errorData.reply.map((error, error_index) => (
                                            <li key={`error_${error_index}`}>{error}</li>
                                        ))}
                                        </ol>
                                    </div>
                                </div>
                            )}
                        
                            <div className="text-center mb-2 mt-3 justify-content-center filter-excel">
                                <div className="d-inline-flex">
                                    {!isProcess.reply
                                    ?
                                        <button
                                            className="btn btn-primary bg-color-blue btn-sm"
                                            type="submit"
                                            onClick={(e) => replyToMessage(e)}
                                        ><span className="fs-6">Send Reply</span></button>
                                    :
                                        <button className="btn btn-primary bg-color-blue btn-sm d-flex" disabled type="submit"><LoaderMedium size={18} /> &nbsp;<span className="fs-6">Sending...</span></button>
                                    }
                                </div>
                            </div>

                            <fieldset className="mt-5">
                                <legend>Replies</legend>
                                <div className="row m-0"> 
                                    {modalLoader.reply
                                    ?
                                        <LoaderMedium size={30} />
                                    :
                                        <>
                                        {contactReplyData?.replies?.length > 0
                                        ?
                                            <div>
                                                {contactReplyData?.replies.map((d_reply, reply_idx) => (
                                                    <fieldset className="mt-3">
                                                        <legend>Reply {reply_idx + 1} (<span>{moment(d_reply?.created_at).format("Do MMM YYYY")}</span>)</legend>
                                                        <div
                                                            key={`reply_${reply_idx}`}
                                                            dangerouslySetInnerHTML={{ 
                                                                __html: DOMPurify.sanitize(d_reply.reply_message, { ADD_TAGS: ["style"] }) 
                                                            }}
                                                        />
                                                    </fieldset>
                                                ))}
                                            </div>
                                        :
                                            <div className="no-fellow">
                                                <p className="mb-0 head">{"No Reply Found!"}</p>
                                            </div>
                                        }
                                        </>
                                    }
                                </div>
                            </fieldset>
                        </Form>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="team-detail">
                <button className="btn btn-secondary" onClick={(e) => toggleModal(e, 'reply', false)}>Close</button>
            </Modal.Footer>
        </Modal>
        </>
    )    
}

export default ManangeSupport;